<!-- Sidebar -->
<p-drawer [(visible)]="visible" [showCloseIcon]="false" position="right" [blockScroll]="true" [dismissible]="false"
styleClass="w-12 lg:w-10 no-header p-0 clients-profile-sidebar" appendTo="body" (onHide)="closeSidebar()" aria-label="client-search-sidebar">
<ng-template #headless>
<!-- Header -->
<div class="border-bottom-1 border-gray-300 relative flex align-items-center justify-content-between px-3 py-2" aria-label="sidebar-header">

  <div [ngClass]="showMobileFilters ? 'hidden' : 'flex'" class="align-items-center">
    <!-- Close Icon -->
    <div class="h-2rem w-2rem cursor-pointer bg-gray-200 flex align-items-center justify-content-center" (click)="closeSidebar()" aria-label="close-sidebar-button">
      <i class="fa fa-times text-xl text-gray-600"></i>
    </div>
    <h4 class="mb-0 ml-2 text-sm font-normal" aria-label="search-results-count">{{ 'CLIENT_OMNISEARCH.SEARCH_RESULTS' | translate }}. <strong class="font-bold">{{totalCount}} {{ 'CLIENT_OMNISEARCH.RESULTS_FOUND' | translate }}.</strong></h4>
  </div>

  <div *ngIf="showMobileFilters" [ngClass]="showMobileFilters ? 'flex' : 'md:hidden'" class="align-items-center">
    <!-- Back Icon -->
    <i (click)="toggleMobileFilters()" class="fa fa-arrow-left text-xl" aria-label="back-to-results-button"></i>
    <h4 class="mb-0 ml-3 text-sm" aria-label="filter-header">{{ 'CLIENT_OMNISEARCH.FILTER' | translate }}</h4>
  </div>

  <div class="hidden md:flex align-items-center text-gray-600 mr-2" aria-label="feedback-section">
    <strong class="block text-xs font-bold">{{ 'CLIENT_OMNISEARCH.HELPFUL' | translate }}</strong>
    <i class="fa-regular fa-thumbs-up cursor-pointer mx-2" aria-label="thumbs-up-button"></i>
    <i class="fa-regular fa-thumbs-down cursor-pointer" aria-label="thumbs-down-button"></i>
  </div>
</div>

<!-- Content -->
<div class="lg:flex text-sm">
  <!-- Filters Button Mobile -->
  <div [ngClass]="showMobileFilters ? 'hidden' : 'lg:hidden flex'" (click)="toggleMobileFilters()" class="bg-gray-200 text-primary py-2 cursor-pointer shadow-1 align-items-center justify-content-center" aria-label="mobile-filters-button">
    <i class="fa fa-filter mr-2"></i>
    <span>{{ 'CLIENT_OMNISEARCH.FILTER' | translate }}</span>
  </div>

  <!-- Filters -->
  <div [ngClass]="showMobileFilters ? '' : 'hidden lg:block'" class="lg:w-4 xl:w-3 surface-0 md:px-3 md:pt-3 lg:pb-3 lg:min-h-screen border-right-1 border-gray-300" aria-label="filters-section">
    <!-- Desktop Filters -->
    <div class="hidden md:block h-auto max-h-screen overflow-y-auto">
      <!-- Centers Filter -->
      <div class="mb-4 pb-2" aria-label="centers-filter">
        <h4 class="mb-0 text-gray-600 text-xs">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_CENTER' | translate }}</h4>
        <ul class="list-none pl-0 pt-2 m-0">
          <li *ngFor="let center of visibleCenters; let i = index" class="flex align-items-center mt-2">
            <p-checkbox [(ngModel)]="center.checked" 
                       [binary]="true"
                       [inputId]="'center_' + center.value" 
                       (onChange)="onFilterChange('center', center.value, $event)"
                       [attr.aria-label]="'center-filter-' + i"></p-checkbox>
            <label [for]="'center_' + center.value" class="ml-2">{{center.label}}</label>
          </li>
          <li *ngIf="centers.length > 4" class="mt-2">
            <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('centers')" aria-label="toggle-centers-button">
              {{ showAllCenters ? ('CLIENT_OMNISEARCH.FILTERS.SHOW_LESS' | translate) : ('CLIENT_OMNISEARCH.FILTERS.SHOW_MORE' | translate) }}
              ({{centers.length - 4}} {{ 'CLIENT_OMNISEARCH.FILTERS.MORE' | translate }})
            </a>
          </li>
        </ul>
      </div>

      <!-- Status Filter -->
      <div class="mb-4 pb-3" aria-label="status-filter">
        <h4 class="mb-0 text-gray-600 text-xs">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_STATUS' | translate }}</h4>
        <ul class="list-none pl-0 pt-2 m-0">
          <li *ngFor="let status of visibleStatuses; let i = index" class="flex align-items-center mt-2">
            <p-checkbox [(ngModel)]="status.checked"
                       [binary]="true"
                       [inputId]="'status_' + status.value"
                       (onChange)="onFilterChange('status', status.value, $event)"
                       [attr.aria-label]="'status_' + status.value"></p-checkbox>
            <label [for]="'status_' + status.value" class="ml-2">{{status.label}}</label>
          </li>
          <li *ngIf="statuses.length > 4" class="mt-2">
            <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('statuses')" aria-label="toggle-statuses-button">
              {{ showAllStatuses ? 'Show less' : 'Show more' }} 
            </a>
          </li>
        </ul>
      </div>

      <!-- Client Rep Filter -->
      <div class="mb-4 pb-2" aria-label="client-rep-filter">
        <h4 class="mb-0 text-gray-600 text-xs">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_CLIENT_REP' | translate }}</h4>
        <ul class="list-none pl-0 pt-2 m-0">
          <li *ngFor="let rep of visibleClientReps; let i = index" class="flex align-items-center mt-2">
            <p-checkbox [(ngModel)]="rep.checked"
                       [binary]="true"
                       [inputId]="'rep_' + rep.value"
                       (onChange)="onFilterChange('clientRep', rep.value, $event)"
                       [attr.aria-label]="'rep-filter-' + i"></p-checkbox>
            <label [for]="'rep_' + rep.value" class="ml-2 flex align-items-center">
              <p-avatar *ngIf="rep.image" [image]="rep.image" styleClass="h-1rem w-1rem" [attr.aria-label]="'rep-avatar-' + i"></p-avatar>
              <p-avatar *ngIf="!rep.image" [label]="rep.label | titlecase | shortName" styleClass="h-1rem w-1rem" [attr.aria-label]="'rep-avatar-' + i"></p-avatar>
              <span class="ml-2">{{rep.label}}</span>
            </label>
          </li>
          <li *ngIf="clientReps.length > 4" class="mt-2">
            <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('clientReps')" aria-label="toggle-reps-button">
              {{ showAllClientReps ? 'Show less' : 'Show more' }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Channel Filter -->
      <div class="mb-4 pb-3" aria-label="channel-filter">
        <h4 class="mb-0 text-gray-600 text-xs">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_CHANNEL' | translate }}</h4>
        <ul class="list-none pl-0 pt-2 m-0">
          <li *ngFor="let channel of visibleChannels; let i = index" class="flex align-items-center mt-2">
            <p-checkbox [(ngModel)]="channel.checked"
                       [binary]="true"
                       [inputId]="'channel_' + channel.value"
                       (onChange)="onFilterChange('channel', channel.value, $event)"
                       [attr.aria-label]="'channel-filter-' + channel.value"></p-checkbox>
            <label [for]="'channel_' + channel.value" class="ml-2">{{channel.label}}</label>
          </li>
          <li *ngIf="channels.length > 4" class="mt-2">
            <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('channels')" aria-label="toggle-channels-button">
              {{ showAllChannels ? 'Show less' : 'Show more' }} 
            </a>
          </li>
        </ul>
      </div>

      <!-- Source Filter -->
      <div class="mb-2 pb-3" aria-label="source-filter">
        <h4 class="mb-0 text-gray-600 text-xs">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_SOURCE' | translate }}</h4>
        <ul class="list-none pl-0 pt-2 m-0">
          <li *ngFor="let source of visibleSources; let i = index" class="flex align-items-center mt-2">
            <p-checkbox [(ngModel)]="source.checked"
                       [binary]="true"
                       [inputId]="'source_' + source.value"
                       (onChange)="onFilterChange('source', source.value, $event)"
                       [attr.aria-label]="'source-filter-' + source.value"></p-checkbox>
            <label [for]="'source_' + source.value" class="ml-2">{{source.label}}</label>
          </li>
          <li *ngIf="sources.length > 4" class="mt-2">
            <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('sources')" aria-label="toggle-sources-button">
              {{ showAllSources ? 'Show less' : 'Show more' }} 
            </a>
          </li>
        </ul>
      </div>

      <!-- Visibility Filter -->
      <div class="mb-2 pb-2" aria-label="visibility-filter">
        <h4 class="mb-0 text-gray-600 text-xs">{{ 'CLIENT_OMNISEARCH.FILTERS.VISIBILITY' | translate }}</h4>
        <ul class="list-none pl-0 pt-2 m-0">
          <li class="flex align-items-center mt-2">
            <p-checkbox checkboxIcon="fa fa-check" [binary]="true" [(ngModel)]="filterState.webLeadsOnly" (onChange)="onVisibilityFilterChange($event)" aria-label="web-leads-filter"></p-checkbox>
            <label class="ml-2">{{ 'CLIENT_OMNISEARCH.FILTERS.WEB_LEADS' | translate }}</label>
          </li>
        </ul>
      </div>
    </div>

    <!-- Mobile Filters Tab -->
    <div class="md:hidden flex h-screen" aria-label="mobile-filters-tab">
      <div class="bg-gray-200 w-4">
        <div (click)="filter1=0" [ngClass]="{'font-bold bg-white': filter1 === 0, '': filter1 !== 0}" class="p-3" [attr.data-testid]="'mobile-filter-tab-' + 0">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_CENTER' | translate }}</div>
        <div (click)="filter1=1" [ngClass]="{'font-bold bg-white': filter1 === 1, '': filter1 !== 1}" class="p-3" [attr.data-testid]="'mobile-filter-tab-' + 1">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_STATUS' | translate }}</div>
        <div (click)="filter1=2" [ngClass]="{'font-bold bg-white': filter1 === 2, '': filter1 !== 2}" class="p-3" [attr.data-testid]="'mobile-filter-tab-' + 2">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_CLIENT_REP' | translate }}</div>
        <div (click)="filter1=3" [ngClass]="{'font-bold bg-white': filter1 === 3, '': filter1 !== 3}" class="p-3" [attr.data-testid]="'mobile-filter-tab-' + 3">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_SOURCE' | translate }}</div>
        <div (click)="filter1=4" [ngClass]="{'font-bold bg-white': filter1 === 4, '': filter1 !== 4}" class="p-3" [attr.data-testid]="'mobile-filter-tab-' + 4">{{ 'CLIENT_OMNISEARCH.FILTERS.BY_CHANNEL' | translate }}</div>
        <div (click)="filter1=5" [ngClass]="{'font-bold bg-white': filter1 === 5, '': filter1 !== 5}" class="p-3" [attr.data-testid]="'mobile-filter-tab-' + 5">{{ 'CLIENT_OMNISEARCH.FILTERS.VISIBILITY' | translate }}</div>
      </div>

      <div class="px-3 pb-3 pt-1 w-8 max-h-screen overflow-y-auto">
        <!-- Filter 1: Centers -->
        <div *ngIf="filter1===0" aria-label="mobile-centers-filter">
          <ul class="list-none pl-0 pt-2 m-0">
            <li *ngFor="let center of visibleCenters; let i = index" class="flex align-items-center mt-2">
              <p-checkbox [ngModel]="filterState.centers.includes(center.value)" 
                         checkboxIcon="fa fa-check" 
                         [value]="center.value" 
                         [inputId]="'mobile_center_' + center.value" 
                         (onChange)="onCenterFilterChange($event)"
                         [attr.aria-label]="'mobile-center-filter-' + i"></p-checkbox>
              <label [for]="'mobile_center_' + center.value" class="ml-2">{{center.label}}</label>
            </li>
            <li *ngIf="centers.length > 4" class="mt-2">
              <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('centers')" aria-label="mobile-toggle-centers-button">
                {{ showAllCenters ? 'Show less' : 'Show more' }} ({{centers.length - 4}} more)
              </a>
            </li>
          </ul>
        </div>

        <!-- Filter 2: Status -->
        <div *ngIf="filter1===1" aria-label="mobile-status-filter">
          <ul class="list-none pl-0 pt-2 m-0">
            <li *ngFor="let status of visibleStatuses; let i = index" class="flex align-items-center mt-2">
              <p-checkbox checkboxIcon="fa fa-check" [value]="status.value" [inputId]="'mobile_status_' + status.value" (onChange)="onStatusFilterChange($event)" [attr.aria-label]="'mobile-status-filter-' + i"></p-checkbox>
              <label [for]="'mobile_status_' + status.value" class="ml-2">{{status.label}}</label>
            </li>
            <li *ngIf="statuses.length > 4" class="mt-2">
              <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('statuses')" aria-label="mobile-toggle-statuses-button">
                {{ showAllStatuses ? 'Show less' : 'Show more' }} ({{statuses.length - 4}} more)
              </a>
            </li>
          </ul>
        </div>

        <!-- Filter 3: Client Rep -->
        <div *ngIf="filter1===2" aria-label="mobile-client-rep-filter">
          <ul class="list-none pl-0 pt-2 m-0">
            <li *ngFor="let rep of visibleClientReps; let i = index" class="flex align-items-center mt-2">
              <p-checkbox checkboxIcon="fa fa-check" [value]="rep.value" [inputId]="'mobile_rep_' + rep.value" (onChange)="onClientRepFilterChange($event)" [attr.aria-label]="'mobile-rep-filter-' + i"></p-checkbox>
              <label [for]="'mobile_rep_' + rep.value" class="ml-2 flex align-items-center">
                <p-avatar *ngIf="rep.image" [image]="rep.image" styleClass="h-1rem w-1rem" [attr.aria-label]="'mobile-rep-avatar-' + i"></p-avatar>
                <p-avatar *ngIf="!rep.image" [label]="rep.label | titlecase | shortName" styleClass="h-1rem w-1rem" [attr.aria-label]="'mobile-rep-avatar-' + i"></p-avatar>
                <span class="ml-2">{{rep.label}}</span>
              </label>
            </li>
            <li *ngIf="clientReps.length > 4" class="mt-2">
              <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('clientReps')" aria-label="mobile-toggle-reps-button">
                {{ showAllClientReps ? 'Show less' : 'Show more' }} ({{clientReps.length - 4}} more)
              </a>
            </li>
          </ul>
        </div>

        <!-- Filter 4: Source -->
        <div *ngIf="filter1===3" aria-label="mobile-source-filter">
          <ul class="list-none pl-0 pt-2 m-0">
            <li *ngFor="let source of visibleSources; let i = index" class="flex align-items-center mt-2">
              <p-checkbox checkboxIcon="fa fa-check" [value]="source.value" [inputId]="'mobile_source_' + source.value" (onChange)="onSourceFilterChange($event)" [attr.aria-label]="'mobile-source-filter-' + i"></p-checkbox>
              <label [for]="'mobile_source_' + source.value" class="ml-2">{{source.label}}</label>
            </li>
            <li *ngIf="sources.length > 4" class="mt-2">
              <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('sources')" aria-label="mobile-toggle-sources-button">
                {{ showAllSources ? 'Show less' : 'Show more' }} ({{sources.length - 4}} more)
              </a>
            </li>
          </ul>
        </div>

        <!-- Filter 5: Channel -->
        <div *ngIf="filter1===4" aria-label="mobile-channel-filter">
          <ul class="list-none pl-0 pt-2 m-0">
            <li *ngFor="let channel of visibleChannels; let i = index" class="flex align-items-center mt-2">
              <p-checkbox checkboxIcon="fa fa-check" [value]="channel.value" [inputId]="'mobile_channel_' + channel.value" (onChange)="onChannelFilterChange($event)" [attr.aria-label]="'mobile-channel-filter-' + i"></p-checkbox>
              <label [for]="'mobile_channel_' + channel.value" class="ml-2">{{channel.label}}</label>
            </li>
            <li *ngIf="channels.length > 4" class="mt-2">
              <a href="javascript:void(0)" class="text-primary text-xs font-medium no-underline" (click)="toggleShowMore('channels')" aria-label="mobile-toggle-channels-button">
                {{ showAllChannels ? 'Show less' : 'Show more' }} ({{channels.length - 4}} more)
              </a>
            </li>
          </ul>
        </div>

        <!-- Filter 6: Visibility -->
        <div *ngIf="filter1===5" aria-label="mobile-visibility-filter">
          <ul class="list-none pl-0 pt-2 m-0">
            <li class="flex align-items-center mt-2">
              <p-checkbox checkboxIcon="fa fa-check" [binary]="true" [(ngModel)]="filterState.webLeadsOnly" (onChange)="onVisibilityFilterChange($event)" aria-label="mobile-web-leads-filter"></p-checkbox>
              <label class="ml-2">{{ 'CLIENT_OMNISEARCH.FILTERS.WEB_LEADS' | translate }}</label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- User Details -->
  <div [ngClass]="showMobileFilters ? 'hidden' : ''" class="lg:w-8 xl:w-9 p-3" aria-label="user-details-section">
    <div *ngIf="loading" class="p-2">
      <div *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]" class="mb-3 p-2 border-round border-2 border-gray-50 hover:bg-white hover:border-primary" [attr.aria-label]="'loading-skeleton-' + i">
        <div class="md:flex align-items-center justify-content-between">
          <div class="flex align-items-center">
            <p-skeleton shape="circle" size="40px" styleClass="mr-2"></p-skeleton>
            <p-skeleton width="150px" height="1.2rem" styleClass="mx-2"></p-skeleton>
            <div class="flex align-items-center">
              <p-skeleton width="120px" height="1rem"></p-skeleton>
            </div>
            <div class="flex align-items-center my-2 ml-2 md:my-0">
              <p-skeleton width="180px" height="1rem"></p-skeleton>
            </div>
          </div>
          <div class="flex ml-2 mt-1 md:m-0">
            <p-skeleton width="120px" height="1.5rem" styleClass="mr-2"></p-skeleton>
            <p-skeleton width="100px" height="1.5rem"></p-skeleton>
          </div>
        </div>
      </div>
    </div>
    <p-scroller #scroller *ngIf="!loading" [items]="filteredClients" [itemSize]="filteredClients.length" [delay]="200" [appendOnly]="true" [autoSize]="true" [showSpacer]="false" [loading]="isLoadingMore" [lazy]="true" (onLazyLoad)="loadMoreResults($event)" [style]="{ width: '100%', height: '82vh' }">
      <ng-template pTemplate="item" let-client let-i="index">
          <!-- Skeleton Loader -->
      <div [ngClass]="{'border-primary surface-0': isClientExpanded(client.clt_id), 'bg-gray-200': !isClientExpanded(client.clt_id)}" 
            class="hover:surface-0 p-2 border-round mb-1 transition-all transition-duration-400 ease-in-out border-2 border-gray-50 hover:border-primary overflow-hidden transform hover:scale-[1.01]"
            (mouseenter)="toggleDetails(client.clt_id)" 
            (mouseleave)="toggleDetails(client.clt_id)"
            [attr.aria-label]="'client-item-' + i">
          <div class="flex align-items-center">
            <div class="inline-flex align-items-center" (click)="goToClientProfileClick(client.clt_id,'overview')" [attr.aria-label]="'client-profile-link-' + i">
            <p-avatar *ngIf="client.clt_image" [image]="client.clt_image" shape="circle" styleClass="cursor-pointer" [attr.aria-label]="'client-avatar-' + i"></p-avatar>
            <p-avatar *ngIf="!client.clt_image" [label]="client.clt_full_name | titlecase | shortName" shape="circle" styleClass="cursor-pointer" [attr.aria-label]="'client-avatar-' + i"></p-avatar>
            <strong class="mx-2 text-primary cursor-pointer transition-colors duration-400 ease-in-out">{{client.clt_full_name}}</strong>
          </div>
            <div class="flex align-items-center">
              <span class="bg-gray-800 w-1rem h-1rem border-circle flex align-items-center justify-content-center mr-2" aria-label="phone-icon">
                <i class="fa fa-phone text-xxs text-white"></i>
              </span>
              <a [href]="'tel:' + client.clt_mobile_country_code + client.clt_mobile_no" class="text-900 transition-colors duration-400 ease-in-out" [attr.aria-label]="'client-phone-' + i">
                {{client.clt_mobile_country_code}} {{client.clt_mobile_no}}
              </a>
            </div>
            <div class="flex align-items-center my-2 ml-2 md:my-0">
              <span class="bg-gray-800 w-1rem h-1rem border-circle flex align-items-center justify-content-center mr-2" aria-label="email-icon">
                <i class="fa fa-envelope text-xxs text-white"></i>
              </span>
              <a [href]="'mailto:' + client.clt_emailid" class="text-900 transition-colors duration-400 ease-in-out" [attr.aria-label]="'client-email-' + i">{{client.clt_emailid}}</a>
            </div>
            <div class="flex ml-2 mt-1 md:mt-0">
              <p-tag styleClass="text-xs text-gray-700 bg-gray-400 font-bold white-space-nowrap mr-2" [attr.aria-label]="'center-tag-' + i">
                <div class="flex align-items-center gap-2">
                  <i class="fa fa-location-dot"></i>
                  <span>{{ getCenterName(client) }}</span>
                </div>
              </p-tag>
              <p-tag *ngIf="client.is_child" styleClass="text-xs text-white bg-orange-500 font-bold white-space-nowrap mr-2" value="Child" aria-label="sidebar-child-tag"></p-tag>
              <p-tag *ngIf="getClientStatusHtml(client.clt_status) as data" [styleClass]="data.class" [value]="data.text" class="text-xxs uppercase font-bold white-space-nowrap" [attr.aria-label]="'status-tag-' + i"></p-tag>
            </div>
            <span *ngIf="client.clt_track_mode && client.clt_track_mode.toLowerCase() == 'clientwebsignup'" class="text-gray-700 fa fa-globe text-lg line-height-1 ml-3" aria-label="web-signup-indicator"></span>
          </div>

          <div [ngClass]="{'max-h-0 opacity-0 -translate-y-2': !isClientExpanded(client.clt_id), 'max-h-20rem opacity-100 translate-y-0': isClientExpanded(client.clt_id)}" 
               class="transition-all ease-in-out overflow-hidden transform transition-linear transition-duration-500">
            <!-- Details -->
            <div class="md:flex border-top-1 border-bottom-1 border-gray-300 py-2 my-2" (click)="$event.stopPropagation()" [attr.aria-label]="'client-details-' + i">
              <div class="md:flex align-items-center justify-content-end">
                <div class="md:flex align-items-center">
                  <div class="mb-2 md:mb-0 md:mr-3">
                    <span class="text-gray-600 text-xs mr-2">{{ 'CLIENT_OMNISEARCH.CLIENT.CLIENT_ID' | translate }}:</span>
                    <strong class="font-bold">{{client.clt_id}}</strong>
                  </div>
                  <div class="flex align-items-center md:mr-3" *ngIf="client.clt_rep_id" [attr.aria-label]="'client-rep-section-' + i">
                    <span>{{ 'CLIENT_OMNISEARCH.CLIENT.CLIENT_REP' | translate }}:</span>
                    <div class="flex align-items-center" *ngIf="getSalesRep(client.clt_rep_id) | async as salesRep">
                        <p-avatar *ngIf="salesRep.staff_image" [image]="salesRep.staff_image" styleClass="w-1rem h-1rem mx-2" shape="circle"></p-avatar>
                        <p-avatar *ngIf="!salesRep.staff_image" [label]="salesRep.name | titlecase | shortName" styleClass="w-1rem h-1rem mx-2" shape="circle"></p-avatar>
                        <strong class="text-blue-300">{{salesRep.name}}</strong>
                    </div>    
                  </div>
                  <div class="mb-2 md:mb-0 md:mr-3" [attr.aria-label]="'client-source-section-' + i">
                    <span class="text-gray-600 text-xs mr-2">{{ 'CLIENT_OMNISEARCH.CLIENT.SOURCE' | translate }}:</span>
                    <strong class="font-bold">{{client.clt_source}}</strong>
                  </div>
                  <div [attr.aria-label]="'client-channel-section-' + i">
                    <span class="text-gray-600 text-xs mr-2">{{ 'CLIENT_OMNISEARCH.CLIENT.CHANNEL' | translate }}:</span>
                    <strong class="font-bold">{{client.clt_channel}}</strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- Quick Actions -->
            <div class="md:flex align-items-center text-gray-600 text-xs" [attr.aria-label]="'client-actions-' + i">
              <div>{{ 'CLIENT_OMNISEARCH.CLIENT.QUICK_ACTIONS' | translate }}:</div>
              <p-button [label]="'CLIENT_OMNISEARCH.CLIENT.SUBSCRIPTIONS' | translate" styleClass="block md:inline-flex text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal" (onClick)="$event.stopPropagation(); goToClientProfileClick(client.clt_id,'subscriptions')" [attr.aria-label]="'subscriptions-button-' + i"></p-button>
              <p-button [label]="'CLIENT_OMNISEARCH.CLIENT.CREATE_BILL' | translate" styleClass="block md:inline-flex text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal" (onClick)="$event.stopPropagation(); goToClientProfileClick(client.clt_id,'pos-addon-charges')" [attr.aria-label]="'create-bill-button-' + i"></p-button>
              <p-button [label]="'CLIENT_OMNISEARCH.CLIENT.BOOK_APPOINTMENT' | translate" styleClass="block md:inline-flex p-0 text-sm text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal" (onClick)="$event.stopPropagation(); showBookAppointment(client.clt_id)" [attr.aria-label]="'book-appointment-button-' + i"></p-button>
              <p-button [label]="'CLIENT_OMNISEARCH.CLIENT.BOOK_CLASS' | translate" styleClass="block md:inline-flex p-0 text-sm text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal" (onClick)="$event.stopPropagation(); showBookClass(client.clt_id)" [attr.aria-label]="'book-class-button-' + i"></p-button>
              <p-button *ngIf="client.clt_status.toLowerCase() !== 'prospect'" [label]="'CLIENT_OMNISEARCH.CLIENT.CHECK_IN' | translate" styleClass="text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal" (onClick)="$event.stopPropagation(); goToClientProfileClick(client.clt_id,'check-in')" [attr.aria-label]="'check-in-button-' + i"></p-button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-scroller>
  </div>
</div>
</ng-template>
</p-drawer> 

<book-appointment *ngIf="showBookAppointmentPopup" [visible]="showBookAppointmentPopup" [clientId]="clientId"
  [startDateTime]="selectedDateTime" [tenantId]="tenantId" (CloseBookAppointment)="CloseBookAppointment($event)"
  aria-label="book-appointment-dialog">
</book-appointment>

<p-dialog *ngIf="showBookClassPopup" [(visible)]="showBookClassPopup" (onHide)="closePopup(false)" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}"
  [style]="{width: '1050px'}" styleClass="no-header-modal overflow-visible book-class-popup" aria-label="book-class-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300" aria-label="book-class-header">
      <h2 class="mb-0 text-sm"><i class="fa fa-plus mr-3 text-500" aria-label="add-icon"></i>{{'CLIENT_OMNISEARCH.CLIENT.BOOK_CLASS' | translate}}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)" aria-label="close-dialog-button"></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="surface-100 text-sm">
      <!-- Loading Overlay -->
      <div *ngIf="isBookingClass" class="absolute top-0 left-0 w-full h-full flex align-items-center justify-content-center z-5" style="background: rgba(0,0,0,0.3)" aria-label="loading-overlay">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" aria-label="loading-spinner"></p-progressSpinner>
      </div>
      <!-- Loading Overlay -->
     <div class="m-5">
        <calendar [onlyTrialAllowed]="true" (emitEvents)="getEventData($event)" aria-label="class-calendar"></calendar>
     </div>
    </div>
    <!-- Content -->
    <!-- Footer -->
  </ng-template>
</p-dialog>
